module.exports = __webpack_public_path__ + "assets/img/sai_imow-evo_hero.c844e6c6.jpg";